export default {
  white: 'hsl(0, 0%, 100%)',
  orange: 'hsl(25, 97%, 53%)',
  'light-grey': 'hsl(217, 12%, 63%)',
  'medium-grey': 'hsl(216, 12%, 54%)',
  'dark-blue': 'hsl(213, 19%, 18%)',
  'very-dark-blue': '#141519',
  'gradient-light-blue': '#212832',
  'gradient-dark-blue': '#171e28',
};
